// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 1320) return "static/chunks/1320-3109315e952b53f0.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2543":"9cf8d0a8508f12a7","3524":"99e4284df8f6e10c","7272":"1abacd3c6c5f21d3","8034":"b72dc90ffd97fb2b"}[chunkId] + ".js";
};